import Vue from "vue";

import { getObjetIndexByKey } from "@/utils/helpers/array.js";
import { isVisible } from "@/utils/helpers/dom.js";
import { capitalize } from "@/utils/helpers/string.js";
import { isEmpty } from "@/utils/helpers/object.js";
import { isNullOrPositiveNumber } from "@/utils/helpers/number.js";
import { getGroupTypeName } from "@/utils/helpers/group.js";

import dayjs from "dayjs";

/**
 * [$appName App name (base on .env VUE_APP_NAME)]
 */
Vue.prototype.$appName = process.env.VUE_APP_NAME;

/**
 * [$dayjs Make dayjs available from everywhere]
 */
Vue.prototype.$dayjs = dayjs;

/**
 * [getObjetIndexByKey Return the index of the first object that contain a key equal to a value in an array]
 * @param  {array} array [An array of objects]
 * @param  {string} key   [The key to test]
 * @param  {string} value [The value to test]
 * @return {int}       [The indexOf the first object matching the filter]
 */
Vue.prototype.getObjetIndexByKey = (array, key, value, debug) => {
    return getObjetIndexByKey(array, key, value, debug);
};

/**
 Temps trans placeholder that will container some translation mechanisme in the future
 */
Vue.prototype.trans = (key, variable) => {
    return key;
};

Vue.prototype.jumpToId = function (id) {
    const element = document.getElementById(id);

    const url = `#${this.$route.path}#${id}`;

    if (element) {
        window.history.pushState({}, "", url);
        element.scrollIntoView();
    }
};

/**
 * [is Visible Check if an element is visible or not (Elements are considered visible if they consume space in the document. )]
 * @return {boolean} [Visible elements have a width or height that is greater than zero]
 */
Vue.prototype.isVisible = (element) => {
    return isVisible(element);
};

/**
 * [Return a string in lower caze except the first letter]
 * @param  {String} string [String to capitalize]
 * @return {String}        [The capitalize string]
 */
Vue.prototype.capitalize = (string) => {
    return capitalize(string);
};

Vue.prototype.isEmpty = (object) => {
    return isEmpty(object);
};

/**
 * isNullOrPositiveNumber Return the result of isNullOrPositiveNumber helper
 */
Vue.prototype.isNullOrPositiveNumber = (value) => {
    return isNullOrPositiveNumber(value);
};

/**
 * getGroupTypeName Return the result of getGroupTypeName helper
 */
Vue.prototype.getGroupTypeName = (value) => {
    return getGroupTypeName(value);
};